/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catch_Boundary_TitleInputs */

const en_catch_boundary_title = /** @type {(inputs: Catch_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong!`)
};

const es_catch_boundary_title = /** @type {(inputs: Catch_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salio mal!`)
};

/**
* | output |
* | --- |
* | "Something went wrong!" |
*
* @param {Catch_Boundary_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const catch_boundary_title = /** @type {((inputs?: Catch_Boundary_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catch_Boundary_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_catch_boundary_title(inputs)
	return es_catch_boundary_title(inputs)
});